// @flow

import styled, { css as styledcss } from 'styled-components';
import LinkComponent from './link';
import css from './css';
import type { StyledLinkProps } from './types';
import type { Theme } from '../../types';

const StyledLink = styled<typeof LinkComponent, Theme, StyledLinkProps>(LinkComponent)`
  ${css}

  ${props => props.caret && styledcss`
    &:after {
      content: ' ›';
    }
  `};
`;

export default StyledLink;
